import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnDestroy,
  OnInit,
  Renderer2,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { Subject } from "rxjs";
import { AuthService } from "~modules/auth/auth.service";

@Component({
  selector: "app-error404-page",
  templateUrl: "./error404-page.component.html",
  styleUrls: ["./error404-page.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterModule],
})
export class Error404PageComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  urlToRedirect: string;

  // eslint-disable-next-line max-params
  constructor(
    private renderer: Renderer2,
    private authService: AuthService,
    private document: Document,
  ) {
    this.urlToRedirect = "/";
  }

  ngOnInit(): void {
    this.authService.isAuthenticated().then((isLoggedIn: boolean) => {
      if (!isLoggedIn) {
        this.renderer.addClass(this.document.body, "bg-white");
      } else {
        this.renderer.removeClass(this.document.body, "bg-white");
      }
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, "bg-white");
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
